import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import csMessages from './locale/cs.json';
import enMessages from './locale/en.json';
import { applyDocumentLanguage, resolveAppLanguage } from './i18n/language';

export async function initI18n(): Promise<void> {
  const language = await resolveAppLanguage();
  applyDocumentLanguage(language);

  if (!i18n.isInitialized) {
    await i18n.use(initReactI18next).init({
      resources: {
        cs: { translation: csMessages },
        en: { translation: enMessages },
      },
      lng: language,
      fallbackLng: 'cs',
      interpolation: {
        escapeValue: false,
      },
    });
    return;
  }

  await i18n.changeLanguage(language);
}

export default i18n;
